import { CalendarEvent } from 'mini-calendar-event-types';
import convertCalendarEventsToDayViewItems from './convertCalendarEventsToDayViewItems';
import convertAllDayCalendarEventsToAllDayItems from './convertAllDayCalendarEventsToAllDayItems';
import DayViewItemsResponse from '../schema/DayViewItemsResponse';

export default function groupEventsByAllDayProperty(events: CalendarEvent[]): DayViewItemsResponse {
    const inDayEvents: CalendarEvent[] = [];
    const allDayEvents: CalendarEvent[] = [];

    events &&
        events.forEach(event =>
            event.IsEffectiveAllDayEvent ? allDayEvents.push(event) : inDayEvents.push(event)
        );

    return {
        inDayItems: convertCalendarEventsToDayViewItems(inDayEvents),
        allDayItems: convertAllDayCalendarEventsToAllDayItems(allDayEvents),
    };
}
